import React, { Component, PropTypes } from 'react';
import { lang } from '../../strings';
import { trackEvent, BAR_SERVICES, LOAD } from '../../utils/analytics';
import { format } from '../../utils/string';

export default class BarSubscriptionDialog extends Component {

   componentDidMount() {
      trackEvent(BAR_SERVICES, LOAD);
   }

   render() {
      let { onClose, onConfirm, barService } = this.props;
      let { description, enabled } = barService;
      
      let actionText = enabled ? lang.barring.dialog.deactivate : lang.barring.dialog.activate;
      let title = actionText + ' ' + description;

      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={onClose}>&times;</a>
               <h2 className="h5 color-dark-blue">{title}</h2>
               <p>{format(lang.barring.dialog.intro, actionText.toLowerCase(), description)}</p>
               {enabled ? <p className="mp-info">{lang.barring.dialog.important}</p> : null}
                  <div className="mp-block" style={{marginTop: enabled ? 0 : 50}}>
                     <div className="mp-block-half">
                        <button type="button" className="mp-submit" onClick={onConfirm}>{actionText}</button>
                     </div>
                     <div className="mp-block-half">
                        <button type="button" className="mp-submit" onClick={onClose}>{lang.barring.dialog.cancel}</button>
                     </div>
                  </div>
            </div>
         </div>
      );
   }
}

BarSubscriptionDialog.propTypes = {
   onClose: PropTypes.func.isRequired,
   onConfirm: PropTypes.func.isRequired,
   barService: PropTypes.object.isRequired
};